/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var PropagateType;
(function (PropagateType) {
    PropagateType[PropagateType["UNKNOWN"] = 0] = "UNKNOWN";
    PropagateType[PropagateType["CROSS_PROCESS"] = 1] = "CROSS_PROCESS";
    PropagateType[PropagateType["CROSS_THREAD"] = 2] = "CROSS_THREAD";
})(PropagateType || (PropagateType = {}));

// 通用key, java端使用的是这个key
// web端无pb, 用专门的key与后端通信
var KTRACE_STR_HEADER_KEY = 'ktrace-str';
// ktrace SSR 模式返回 Cookie 名称
var KTRACE_CONTEXT = 'ktrace-context';

// segment最大span数量
var MAX_SPAN_LENGTH = 1000;
// 最大tag数量
var MAX_TAG_LENGTH = 100;
// 最大log数量
var MAX_LOG_LENGTH = 10;

var VERSION = 1;

var HOST_ONLINE = 'https://web-trace.ksapisrv.com';
var HOST_INTERNAL = 'http://ktrace-web-server.internal';
var INFO_PATH = '/ktrace/info';
var COLLECT_PATH = '/ktrace/collect';

// 采样类型与java端保持一致, 从0开始
// 大于等于3 sampleRate才生效
var SampleType;
(function (SampleType) {
    SampleType[SampleType["UNKNOWN"] = 0] = "UNKNOWN";
    SampleType[SampleType["NEVER"] = 1] = "NEVER";
    SampleType[SampleType["ALWAYS"] = 2] = "ALWAYS";
    SampleType[SampleType["RATE"] = 3] = "RATE";
    SampleType[SampleType["RATE_LIMIT"] = 4] = "RATE_LIMIT";
    SampleType[SampleType["CUSTOMIZE"] = 5] = "CUSTOMIZE";
})(SampleType || (SampleType = {}));

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = ms;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* Active `debug` instances.
	*/
	createDebug.instances = [];

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return match;
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.enabled = createDebug.enabled(namespace);
		debug.useColors = createDebug.useColors();
		debug.color = selectColor(namespace);
		debug.destroy = destroy;
		debug.extend = extend;
		// Debug.formatArgs = formatArgs;
		// debug.rawLog = rawLog;

		// env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		createDebug.instances.push(debug);

		return debug;
	}

	function destroy() {
		const index = createDebug.instances.indexOf(this);
		if (index !== -1) {
			createDebug.instances.splice(index, 1);
			return true;
		}
		return false;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}

		for (i = 0; i < createDebug.instances.length; i++) {
			const instance = createDebug.instances[i];
			instance.enabled = createDebug.enabled(instance.namespace);
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

var common = setup;

var browser = createCommonjsModule(function (module, exports) {
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */
function log(...args) {
	// This hackery is required for IE8/9, where
	// the `console.log` function doesn't have 'apply'
	return typeof console === 'object' &&
		console.log &&
		console.log(...args);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};
});
var browser_1 = browser.log;
var browser_2 = browser.formatArgs;
var browser_3 = browser.save;
var browser_4 = browser.load;
var browser_5 = browser.useColors;
var browser_6 = browser.storage;
var browser_7 = browser.colors;

function isBrowser() {
    return typeof window !== 'undefined';
}
function isNode() {
    return typeof self === 'undefined'
        && typeof process !== 'undefined'
        && Object.prototype.toString.call(process) === '[object process]';
}
function isProd() {
    return "production" === 'production';
}
function isKtraceInternalUrl(url) {
    return [INFO_PATH, COLLECT_PATH].some(function (path) { return url.endsWith(path); });
}
function isFunction(fn) {
    return typeof fn === 'function';
}
function toTypeString(val) {
    return Object.prototype.toString.call(val);
}
function isPlainObject(obj) {
    return toTypeString(obj) === '[object Object]';
}
function isHeader(obj) {
    return toTypeString(obj) === '[object Headers]';
}

function isBrowser$1() {
    return typeof window !== 'undefined';
}

var sharedPerformance;
if (isBrowser$1()) {
    sharedPerformance = performance;
}
else {
    sharedPerformance = {
        now: function () { },
        timing: {},
        navigation: {},
        timeOrigin: Date.now(),
    };
}

function base64Encode(str) {
    try {
        return btoa(str);
    }
    catch (_a) {
        return str;
    }
}
function base64Decode(str) {
    try {
        return atob(str);
    }
    catch (_a) {
        return str;
    }
}

/**
 * 返回一个正则表达式
 *      匹配 condition 中任意一项
 * @param condition
 * @return {RegExp | null}
 */
function createReg(condition) {
    var arr = condition
        .filter(function (item) { return !!item; })
        .map(function (item) {
        if (item instanceof RegExp) {
            return item.source;
        }
        return item;
    });
    if (arr.length) {
        return new RegExp(arr.join('|'));
    }
    return null;
}
function isShouldIgnore(ignoreList, str) {
    var reg = createReg(ignoreList);
    return reg && reg.test(str);
}
function getPathnameFromUrl(url) {
    if (isBrowser() && window.URL && window.URL.prototype && ('href' in window.URL.prototype)) {
        try {
            var urlObj = new URL(url);
            return urlObj.pathname || '/';
        }
        catch (e) {
            return url;
        }
    }
    return url;
}
function getRandomString(str, len) {
    var res = [];
    while (len--) {
        var index = Math.floor(Math.random() * str.length);
        res.push(str[index]);
    }
    return res.join('');
}

// 分布式id
var separator = '.';
var distributeIdLen = 5;
var serviceNameSlice = 8;
var counter = 1000;
// serviceName是不区分大小写的, 为保证charCodeAt后是两位数, 全部会转为大写
// 把一个string转为number, 先转大写, 然后拼接
function parseServiceNameToNumber(serviceName) {
    return Array.from(serviceName.slice(-serviceNameSlice))
        .map(function (item) { return item.toUpperCase().charCodeAt(0); })
        .join('');
}
function createDistributeId(serviceName) {
    var idArr = [
        "" + VERSION,
        "" + parseServiceNameToNumber(serviceName),
        "" + getRandomString('123456789', 8),
        "" + Date.now(),
        "" + counter++,
    ];
    return base64Encode(idArr.join(separator));
}
function parseDistributeId(str) {
    var idArr;
    try {
        idArr = base64Decode(str).split(separator);
    }
    catch (_a) {
        return {};
    }
    if (idArr.length !== distributeIdLen) {
        return {};
    }
    return {
        version: parseInt(idArr[0], 10),
        serviceInstanceId: parseInt(idArr[1], 10),
        threadId: parseInt(idArr[2], 10),
        timestamp: parseInt(idArr[3], 10),
        counter: parseInt(idArr[4], 10),
    };
}
// 把分布式id转为string
function parseDistributeIdToString(distributeId) {
    var idArr = [
        "" + distributeId.version,
        "" + distributeId.serviceInstanceId,
        "" + distributeId.threadId,
        "" + distributeId.timestamp,
        "" + distributeId.counter,
    ];
    return base64Encode(idArr.join(separator));
}

// fork from https://github.com/othiym23/shimmer/blob/master/index.js
var log = browser('ktrace:util:patch');
function defineProperty(obj, key, value) {
    // eslint-disable-next-line no-prototype-builtins
    var enumerable = !!obj[key] && obj.propertyIsEnumerable(key);
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: enumerable,
        writable: true,
        value: value,
    });
}
function patch(source, name, wrapper) {
    var _a;
    if (!source || !source[name]) {
        log('no source to patch');
        return;
    }
    if (!isFunction(source[name])) {
        log(name + " should be function");
        return;
    }
    if (!isFunction(wrapper)) {
        log("wrapper should be function: " + name);
        return;
    }
    var original = source[name];
    if (original.__ktrace_patched__) {
        log(name + " has already been patched");
        return;
    }
    var wrapped = wrapper(original, name);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (!isFunction(wrapped)) {
        log("wrapped should be function: " + wrapped + ", " + name);
        return;
    }
    try {
        wrapped.prototype = (_a = wrapped.prototype) !== null && _a !== void 0 ? _a : {};
        defineProperty(wrapped, '__ktrace_original__', original);
        defineProperty(wrapped, '__ktrace_unPatch__', function () {
            if (source[name] === wrapped) {
                defineProperty(source, name, original);
            }
        });
        defineProperty(wrapped, '__ktrace_patched__', true);
        defineProperty(source, name, wrapped);
    }
    catch (e) {
        log(name + " defineProperty error: " + e + "'");
    }
}
function unpatch(source, name) {
    if (!source || !source[name]) {
        log('no source to unPatch');
        return;
    }
    if (!isFunction(source[name].__ktrace_unPatch__)) {
        log(name + " has already been unPatched?");
        return;
    }
    source[name].__ktrace_unPatch__();
}

// Span的时间, 内部使用hrTime格式[seconds, nanos], 方便计算
var NANO_DIGIT = 9;
var SECOND_TO_NANO = Math.pow(10, NANO_DIGIT);
var MILLI_TO_NANO = Math.pow(10, 6);
var SECOND_TO_MILLI = Math.pow(10, 3);
// Math.trunc的polyfill
if (!Math.trunc) {
    Math.trunc = function (v) {
        v = +v;
        // eslint-disable-next-line
        return (v - v % 1) || (!isFinite(v) || v === 0 ? v : v < 0 ? -0 : 0);
    };
}
function getTimeOrigin() {
    var timeOrigin = sharedPerformance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        return timeOrigin;
    }
    // @ts-ignore
    return sharedPerformance.timing.fetchStart;
}
// 毫秒时间戳转换为HrTime
function timestampToHrTime(timestamp) {
    var n = timestamp / 1000;
    var seconds = Math.trunc(n);
    var nanos = Number((n - seconds).toFixed(NANO_DIGIT)) * SECOND_TO_NANO;
    return [seconds, nanos];
}
// hrtime转换为毫秒时间戳
function hrTimeToMillis(hrTime) {
    return Math.round(hrTime[0] * SECOND_TO_MILLI + hrTime[1] / MILLI_TO_NANO);
}
// hrTime转换为纳秒时间
function hrTimeToNanos(hrTime) {
    return hrTime[0] * SECOND_TO_NANO + hrTime[1];
}
// 当前hr时间戳
function now() {
    var originHrTime = timestampToHrTime(getTimeOrigin());
    var nowHrTime = timestampToHrTime(sharedPerformance.now());
    var seconds = originHrTime[0] + nowHrTime[0];
    var nanos = originHrTime[1] + nowHrTime[1];
    // Nanoseconds
    if (nanos > SECOND_TO_NANO) {
        nanos -= SECOND_TO_NANO;
        seconds += 1;
    }
    return [seconds, nanos];
}
// hrtime时间差
function diffHrTime(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    if (nanos < 0) {
        seconds -= 1;
        nanos += SECOND_TO_NANO;
    }
    return [seconds, nanos];
}
function isHrTime(time) {
    return (Array.isArray(time)
        && time.length === 2
        && typeof time[0] === 'number'
        && typeof time[1] === 'number');
}
function parseInputTime(time) {
    // 输入的时间不应该比起点时间还小
    if (isHrTime(time)) {
        if (hrTimeToMillis(time) < getTimeOrigin()) {
            return now();
        }
        return time;
    }
    if (typeof time === 'number') {
        if (time < getTimeOrigin()) {
            return now();
        }
        return timestampToHrTime(time);
    }
    return null;
}

var log$1 = browser('ktrace:core:Span');
var Span = /** @class */ (function () {
    function Span(_a) {
        var tracer = _a.tracer, segment = _a.segment, context = _a.context, operationName = _a.operationName, componentType = _a.componentType, componentName = _a.componentName, spanId = _a.spanId, parentSpanId = _a.parentSpanId, peerInfo = _a.peerInfo, startTime = _a.startTime;
        this._isEnd = false;
        this._tags = {};
        this._logs = [];
        this._errorOccurred = false;
        this._duration = 0;
        // 是否手动设置过duration, 如果设置过, end的时候不再计算duration
        this._hasSetDuration = false;
        this.tracer = tracer;
        this.segment = segment;
        this.context = context;
        this.componentType = componentType;
        this.componentName = componentName;
        this.spanId = spanId;
        this.parentSpanId = parentSpanId;
        this._peerInfo = peerInfo;
        this._operationName = operationName;
        this._startTime = parseInputTime(startTime) || now();
        // 创建span的时候就把span加到segment
        this.segment.addSpan(this);
    }
    Object.defineProperty(Span.prototype, "errorOccurred", {
        get: function () {
            return this._errorOccurred;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "operationName", {
        get: function () {
            return this._operationName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "tags", {
        get: function () {
            return this._tags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "logs", {
        get: function () {
            return this._logs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "startTime", {
        get: function () {
            return this._startTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "peerInfo", {
        get: function () {
            return this._peerInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "startNanos", {
        get: function () {
            return hrTimeToNanos(this._startTime);
        },
        enumerable: false,
        configurable: true
    });
    Span.prototype.setStartTime = function (startTime) {
        this._startTime = parseInputTime(startTime) || now();
        return this;
    };
    // duration, 传入的毫秒数会转换为纳秒
    // 这里传毫秒数主要是为了与startSpan里面的startTime统一, 那里通常会传unix timestamp
    Span.prototype.setDuration = function (duration) {
        this._duration = duration * MILLI_TO_NANO;
        this._hasSetDuration = true;
        return this;
    };
    Span.prototype.updateName = function (operationName) {
        this._operationName = operationName;
        return this;
    };
    Span.prototype.setError = function (error) {
        this._errorOccurred = true;
        if (error instanceof Error) {
            this.log({
                name: error.name,
                message: error.message,
                stack: error.stack,
            });
        }
        return this;
    };
    Span.prototype.setTag = function (key, value) {
        if (this.isEnd()) {
            return this;
        }
        var len = Object.keys(this._tags).length;
        if (len >= MAX_TAG_LENGTH) {
            log$1('tag length is reached the limit');
            return this;
        }
        this._tags[key] = value;
        return this;
    };
    Span.prototype.setTags = function (tags) {
        var _this = this;
        if (this.isEnd()) {
            return this;
        }
        Object.keys(tags).forEach(function (key) {
            _this.setTag(key, tags[key]);
        });
        return this;
    };
    Span.prototype.log = function (logData, logTime) {
        if (this.isEnd()) {
            return this;
        }
        if (this._logs.length >= MAX_LOG_LENGTH) {
            log$1('log length is reached the limit');
            return this;
        }
        var data = typeof logData === 'string' ? { log: logData } : logData;
        this._logs.push({
            timestamp: logTime !== null && logTime !== void 0 ? logTime : Date.now(),
            data: __assign({}, data),
        });
        return this;
    };
    // 代表远程请求节点信息
    Span.prototype.setPeerInfo = function (obj) {
        this._peerInfo = Object.assign({}, this._peerInfo, obj);
        return this;
    };
    Span.prototype.end = function (endTime) {
        if (this.isEnd()) {
            log$1('span is already ended');
            return;
        }
        this._isEnd = true;
        if (!this.segment) {
            log$1('span on segment not found');
            return;
        }
        // 没设置duration的时候手动设置duration
        if (!this._hasSetDuration) {
            var endHrTime = parseInputTime(endTime) || now();
            this._duration = hrTimeToNanos(diffHrTime(this._startTime, endHrTime));
        }
        this.segment.endSpan(this);
    };
    Span.prototype.isEnd = function () {
        if (this._isEnd) {
            log$1('span is end');
        }
        return this._isEnd;
    };
    return Span;
}());

var log$2 = browser('ktrace:core:Segment');
var Segment = /** @class */ (function () {
    function Segment(_a) {
        var tracer = _a.tracer, traceId = _a.traceId, segmentId = _a.segmentId, processInfo = _a.processInfo, segmentRefs = _a.segmentRefs;
        this._spanTotal = 0;
        this._spans = [];
        this._relatedTraceIds = []; // 关联的traceId, 通常只有一条
        if (!traceId) {
            log$2('traceId is needed');
            return;
        }
        if (!segmentId) {
            log$2('segmentId is needed');
        }
        this._tracer = tracer;
        this._segmentId = segmentId;
        this._processInfo = processInfo;
        this._segmentRefs = segmentRefs;
        this._relatedTraceIds.push(traceId);
    }
    Object.defineProperty(Segment.prototype, "spanLength", {
        get: function () {
            return this._spanTotal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Segment.prototype, "segmentId", {
        get: function () {
            return this._segmentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Segment.prototype, "processInfo", {
        get: function () {
            return this._processInfo;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Segment.prototype, "segmentRefs", {
        get: function () {
            return this._segmentRefs;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Segment.prototype, "spans", {
        get: function () {
            return this._spans;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Segment.prototype, "relatedTraceIds", {
        get: function () {
            return this._relatedTraceIds;
        },
        enumerable: false,
        configurable: true
    });
    Segment.prototype.addSpan = function (span) {
        if (this._spans.length >= MAX_SPAN_LENGTH) {
            log$2('span length is reached the limit');
            return this;
        }
        this._spanTotal++;
        return this;
    };
    // 结束span
    Segment.prototype.endSpan = function (span) {
        this._spans.push(span);
        // 当span全部结束的时候, 就把segment发送出去
        if (this._spans.length >= this._spanTotal) {
            this._tracer.export(this);
        }
    };
    // 关联的traceId, 目前只有一条, 所以这个方法可能用不上
    Segment.prototype.addTraceId = function (traceId) {
        if (this._relatedTraceIds.includes(traceId)) {
            log$2("traceId is exist: " + traceId);
            return;
        }
        this._relatedTraceIds.push(traceId);
        return this;
    };
    return Segment;
}());

var Context = /** @class */ (function () {
    function Context(_a) {
        var _b = _a.version, version = _b === void 0 ? VERSION : _b, traceId = _a.traceId, segmentId = _a.segmentId, spanId = _a.spanId, serviceName = _a.serviceName, bizName = _a.bizName, sampleDecision = _a.sampleDecision, _c = _a.baggageItems, baggageItems = _c === void 0 ? 'NA' : _c;
        this._version = version;
        this._traceId = traceId;
        this._segmentId = segmentId;
        this._spanId = spanId;
        this._serviceName = serviceName;
        this._bizName = bizName;
        this._sampleDecision = sampleDecision;
        this._baggageItems = baggageItems;
    }
    Context.prototype.toString = function () {
        return [
            this._version,
            this._traceId,
            this._segmentId,
            this._spanId,
            this._serviceName,
            this._bizName,
            this._sampleDecision,
            this._baggageItems,
        ].join('|');
    };
    // 转成用来生成proto buffer的对象, baggageItems在string中是NA, 在proto中是{}
    Context.prototype.toProtoObject = function () {
        return {
            version: this._version,
            primaryTraceId: parseDistributeId(this._traceId),
            segmentId: parseDistributeId(this._segmentId),
            spanId: this._spanId,
            serviceName: this._serviceName,
            bizName: this.bizName,
            sampled: this._sampleDecision,
            baggageItems: {},
        };
    };
    Context.fromString = function (str) {
        if (!str) {
            return null;
        }
        var arr = str.split('|');
        if (arr.length < 8) {
            return null;
        }
        return new Context({
            version: parseInt(arr[0], 10),
            traceId: arr[1],
            segmentId: arr[2],
            spanId: parseInt(arr[3], 10),
            serviceName: arr[4],
            bizName: arr[5],
            sampleDecision: arr[6] === 'true',
            baggageItems: arr[7],
        });
    };
    // 从protoMessage生成context
    Context.fromProto = function (protoMessage) {
        var e_1, _a;
        var keys = ['version', 'primaryTraceId', 'segmentId', 'spanId', 'serviceName', 'bizName', 'sampled'];
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                if (typeof protoMessage[key] === 'undefined') {
                    return null;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return new Context({
            version: protoMessage.version,
            traceId: parseDistributeIdToString(protoMessage.primaryTraceId),
            segmentId: parseDistributeIdToString(protoMessage.segmentId),
            spanId: protoMessage.spanId,
            serviceName: protoMessage.serviceName,
            bizName: protoMessage.bizName,
            sampleDecision: protoMessage.sampled,
        });
    };
    Object.defineProperty(Context.prototype, "traceId", {
        get: function () {
            return this._traceId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "segmentId", {
        get: function () {
            return this._segmentId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "spanId", {
        get: function () {
            return this._spanId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "bizName", {
        get: function () {
            return this._bizName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "serviceName", {
        get: function () {
            return this._serviceName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Context.prototype, "sampleDecision", {
        get: function () {
            return this._sampleDecision;
        },
        enumerable: false,
        configurable: true
    });
    return Context;
}());

function recordToString(record) {
    var res = {};
    Object.keys(record).forEach(function (key) {
        res["" + key] = "" + record[key];
    });
    return res;
}
var KtraceExporter = /** @class */ (function () {
    function KtraceExporter() {
    }
    KtraceExporter.prototype.export = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!data) {
                reject(null);
                return;
            }
            var ktraceData = _this._parseSegment(data);
            resolve(ktraceData);
        });
    };
    KtraceExporter.prototype._parseSegment = function (data) {
        return {
            segmentId: parseDistributeId(data.segmentId),
            processInfo: __assign({}, data.processInfo),
            relatedTraceId: __spread(data.relatedTraceIds.map(parseDistributeId)),
            segmentRef: __spread(data.segmentRefs.map(function (segmentRef) {
                return Object.assign({}, segmentRef, {
                    segmentId: parseDistributeId(segmentRef.segmentId),
                });
            })),
            span: __spread(data.spans.map(this._parseSpan.bind(this))),
        };
    };
    // 再对peerInfo做下保护
    KtraceExporter.prototype._parsePeerInfo = function (peerInfo) {
        if (typeof peerInfo.port !== 'undefined') {
            peerInfo.port = Number(peerInfo.port) || 0;
        }
        return peerInfo;
    };
    KtraceExporter.prototype._parseSpan = function (span) {
        return {
            id: span.spanId,
            parentSpanId: span.parentSpanId,
            componentType: span.componentType,
            componentName: span.componentName,
            operationName: span.operationName,
            errorOccurred: span.errorOccurred,
            // 上报的时候, tag和log需要是map<string, string>, 否则报错, 这个有点坑
            tags: __assign({}, recordToString(span.tags)),
            logEntity: __spread(span.logs.map(function (log) {
                return {
                    timestamp: log.timestamp,
                    data: recordToString(log.data),
                };
            })),
            // 这三个时间要求是整数, 需要注意数据精度
            startTimeInMillis: Math.floor(hrTimeToMillis(span.startTime)),
            startNanos: Math.floor(span.startNanos),
            durationInNanos: Math.floor(span.duration),
            peerInfo: __assign({}, this._parsePeerInfo(span.peerInfo)),
        };
    };
    return KtraceExporter;
}());

var log$3 = browser('ktrace:core:RemoteTransport');
var RemoteTransport = /** @class */ (function () {
    function RemoteTransport(tracer) {
        var _this = this;
        this._pool = [];
        this._maxPool = 100;
        this._interval = 10 * 1000; // 10秒或者达到100条数据发送一次
        this._timer = null; // timer在各平台类型不一样, 先写any
        this._tracer = tracer;
        this._start();
        if (isBrowser()) {
            var eventName = 'onpagehide' in window ? 'pagehide' : 'beforeunload';
            window.addEventListener(eventName, function () {
                _this._flush();
            }, false);
        }
    }
    RemoteTransport.prototype._start = function () {
        var _this = this;
        if (this._timer) {
            clearTimeout(this._timer);
        }
        this._timer = setTimeout(function () {
            _this._flush();
        }, this._interval);
    };
    RemoteTransport.prototype.dispose = function () {
        clearTimeout(this._timer);
    };
    RemoteTransport.prototype.send = function (data) {
        this._pool.push(data);
        if (this._pool.length >= this._maxPool) {
            this._flush();
        }
    };
    RemoteTransport.prototype._flush = function () {
        this._sendData(__spread(this._pool));
        this._pool = [];
        // flush之后重新开始计时
        this._start();
    };
    // 容错及重试机制后续再考虑
    RemoteTransport.prototype._sendData = function (pool) {
        if (!Array.isArray(pool) || !pool.length) {
            return;
        }
        var host = isNode() && isProd() ? HOST_INTERNAL : HOST_ONLINE;
        var url = "" + host + COLLECT_PATH;
        log$3("sendUrl: " + url);
        log$3("pool: " + pool.length + " " + JSON.stringify(pool, null, 2));
        // 捕获一下, 防止UnhandledPromiseRejection
        this._tracer.httpAgent({
            method: 'post',
            url: url,
            data: {
                serviceName: this._tracer.serviceName,
                data: __spread(pool),
            },
        }).then(function () {
            log$3('send success');
        }).catch(function (e) {
            log$3('send fail:', e);
        });
    };
    return RemoteTransport;
}());

var ConsoleTransport = /** @class */ (function () {
    function ConsoleTransport() {
    }
    ConsoleTransport.prototype.send = function (data) {
        console.log(JSON.stringify(data, null, 2));
    };
    ConsoleTransport.prototype.dispose = function () { };
    return ConsoleTransport;
}());

var NoopSpan = /** @class */ (function () {
    function NoopSpan(options) {
        var _a;
        this.context = (_a = options === null || options === void 0 ? void 0 : options.context) !== null && _a !== void 0 ? _a : null;
    }
    NoopSpan.prototype.updateName = function (operationName) {
        return this;
    };
    NoopSpan.prototype.setError = function () {
        return this;
    };
    NoopSpan.prototype.setTag = function (key, value) {
        return this;
    };
    NoopSpan.prototype.setTags = function (tags) {
        return this;
    };
    NoopSpan.prototype.log = function (logs, logTime) {
        return this;
    };
    NoopSpan.prototype.end = function (endTime) { };
    NoopSpan.prototype.setDuration = function (duration) {
        return this;
    };
    NoopSpan.prototype.setStartTime = function (startTime) {
        return this;
    };
    NoopSpan.prototype.setPeerInfo = function (obj) {
        return this;
    };
    NoopSpan.prototype.isEnd = function () {
        return true;
    };
    return NoopSpan;
}());

var BaseContextManager = /** @class */ (function () {
    function BaseContextManager() {
        this._activeContext = null;
    }
    BaseContextManager.prototype.getActive = function () {
        return this._activeContext;
    };
    BaseContextManager.prototype.setActive = function (ctx) {
        this._activeContext = ctx;
        return ctx;
    };
    BaseContextManager.prototype.clear = function () {
        this._activeContext = null;
    };
    BaseContextManager.prototype.withContext = function (context, fn) { };
    return BaseContextManager;
}());

var log$4 = browser('ktrace:core:BaseTracer');
var rootSpanId = -1;
var noopSpanSegmentId = 'NOOPSPAN_SEGMENT_ID';
var Tracer = /** @class */ (function () {
    function Tracer(options) {
        var _a, _b, _c;
        this._segmentPool = new Map();
        this._bizName = "unknown" /* UNKNOWN */; // bizName默认为unknown, 具体的从info接口获取
        this._processInfo = {};
        this._isInWhiteList = false;
        this._userId = '';
        // 从info接口获取的userId白名单
        // 只有node端会下发, 保存在内存里
        this._userWhiteList = [];
        if (!options.serviceName) {
            throw new Error('serviceName is needed');
        }
        this._serviceName = options.serviceName;
        this._exporter = (_a = options.exporter) !== null && _a !== void 0 ? _a : new KtraceExporter();
        // debug为调试模式, 会百分百采样, 但只会打印日志, 不会发出任何日志
        this._isDebug = !!options.debug;
        this._transport = this._isDebug
            ? new ConsoleTransport()
            : (_b = options.transport) !== null && _b !== void 0 ? _b : new RemoteTransport(this);
        this._contextManager = (_c = options.contextManager) !== null && _c !== void 0 ? _c : new BaseContextManager();
        this.ignoreUrlList = Array.isArray(options.ignoreUrlList) ? options.ignoreUrlList : [];
        this.ignoreGrpcMethodList = Array.isArray(options.ignoreGrpcMethodList) ? options.ignoreGrpcMethodList : [];
        this.ignoreDnsHostList = Array.isArray(options.ignoreDnsHostList) ? options.ignoreDnsHostList : [];
        // 即使不采样, 也会生成traceId
        this.alwaysCreateTraceId = !!options.alwaysCreateTraceId;
    }
    Object.defineProperty(Tracer.prototype, "serviceName", {
        get: function () {
            return this._serviceName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tracer.prototype, "contextManager", {
        get: function () {
            return this._contextManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tracer.prototype, "httpAgent", {
        get: function () {
            return this._httpAgent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tracer.prototype, "userId", {
        get: function () {
            return this._userId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tracer.prototype, "userWhiteList", {
        get: function () {
            return this._userWhiteList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tracer.prototype, "traceId", {
        // traceId只有在特别的插件运行时才能取到
        get: function () {
            var _a, _b;
            return (_b = (_a = this._contextManager.getActive()) === null || _a === void 0 ? void 0 : _a.traceId) !== null && _b !== void 0 ? _b : '';
        },
        enumerable: false,
        configurable: true
    });
    Tracer.prototype._setProcessInfo = function (processInfo) {
        if (processInfo === void 0) { processInfo = {}; }
        this._processInfo = __assign({ bizName: this._bizName, serviceName: this._serviceName }, processInfo);
    };
    // 从服务端获取trace信息, 由终端实现
    Tracer.prototype._setTraceInfo = function (_a) {
        var bizName = _a.bizName, sampleConfig = _a.sampleConfig, isInWhiteList = _a.isInWhiteList, userWhiteList = _a.userWhiteList;
        this._bizName = bizName;
        this._updateBizName(bizName);
        this._sampleConfig = sampleConfig;
        this._isInWhiteList = isInWhiteList;
        this._userWhiteList = userWhiteList;
    };
    Tracer.prototype._updateBizName = function (bizName) {
        this._processInfo.bizName = bizName;
    };
    Tracer.prototype._setHttpAgent = function (httpAgent) {
        this._httpAgent = httpAgent;
    };
    Tracer.prototype._setUserId = function (userId) {
        this._userId = userId;
    };
    // 获取最终采样决策
    // 是否要进行更严格的控制: 比如不允许设置为ALWAYS, 以及sampleRate不允许为1
    Tracer.prototype._getSampleDecision = function () {
        // debug模式下会全采样, 但不会发送, 只会console.log
        if (this._isDebug || this._isInWhiteList) {
            return true;
        }
        if (!this._sampleConfig) {
            return false;
        }
        if (this._sampleConfig.sampleType === SampleType.ALWAYS) {
            return true;
        }
        if (this._sampleConfig.sampleType === SampleType.UNKNOWN || this._sampleConfig.sampleType === SampleType.NEVER) {
            return false;
        }
        if (this._sampleConfig.sampleType >= SampleType.RATE) {
            if (typeof this._sampleConfig.sampleRate !== 'number') {
                return false;
            }
            var shouldSample = Math.random() < this._sampleConfig.sampleRate;
            // 自定义采样
            if (this._sampleConfig.sampleType === SampleType.CUSTOMIZE && isFunction(this._customSampleFn)) {
                return shouldSample || this._customSampleFn();
            }
            return shouldSample;
        }
        return false;
    };
    Tracer.prototype._isContextValid = function (ctx) {
        return !!ctx
            && [
                ctx.traceId,
                ctx.spanId,
                ctx.segmentId,
                ctx.bizName,
                ctx.serviceName,
                ctx.sampleDecision,
            ].every(function (item) { return typeof item !== 'undefined'; });
    };
    // 生成子span, context会默认作为parent
    Tracer.prototype.startSpan = function (operationName, options) {
        // parentContext优先取parent指定的, 否则取_activeContext
        var parentContext;
        if ((options === null || options === void 0 ? void 0 : options.parent) instanceof Span) {
            parentContext = (options === null || options === void 0 ? void 0 : options.parent).context;
        }
        else {
            // 这里不能用双问号, 如果option.context为null, 也会取_activeContex
            // 一个场景是node端的首屏trace
            parentContext = (options === null || options === void 0 ? void 0 : options.context) || this._contextManager.getActive();
        }
        var traceId = '';
        var parentSpanId = rootSpanId;
        var segmentRefs = [];
        // 如果上游Context合法且采样
        if (this._isContextValid(parentContext) && !!(parentContext === null || parentContext === void 0 ? void 0 : parentContext.sampleDecision)) {
            traceId = parentContext.traceId;
            parentSpanId = parentContext.spanId;
            // 在最终trace链路的计算中, 只有segmentId和spanId有用。这里优先用parentContext的数据更合适
            segmentRefs = [{
                    propagateType: PropagateType.CROSS_PROCESS,
                    segmentId: parentContext.segmentId,
                    spanId: parentSpanId,
                    serviceName: parentContext.serviceName || this._serviceName,
                    bizName: parentContext.bizName || this._bizName,
                    sampled: true,
                }];
            // 是NoopSpanContext, 且要生成traceId
            // NoopSpan的后代span走这里
        }
        else if (this.alwaysCreateTraceId && (parentContext === null || parentContext === void 0 ? void 0 : parentContext.segmentId) === noopSpanSegmentId) {
            log$4('create traceid for noopSpan');
            return this._createNoopSpanWithContext(parentContext);
            // 如果最终采样决策不采样
            // 第一次生成NoopSpan走这里
        }
        else if (!this._getSampleDecision()) {
            log$4('sampleDecision is false');
            return this._createNoopSpanWithContext(parentContext);
        }
        else {
            traceId = createDistributeId(this._serviceName);
        }
        // 如果使用了上游的parentContext, 并且parentContext.segmentId在_segmentPool里, 就用同一个segment
        // 否则启动一个新的segment, parentSpanId为rootSpanId
        var segment;
        if (segmentRefs.length && this._segmentPool.has(parentContext.segmentId)) {
            segment = this._segmentPool.get(parentContext.segmentId);
        }
        else {
            segment = new Segment({
                tracer: this,
                traceId: traceId,
                segmentId: createDistributeId(this._serviceName),
                segmentRefs: segmentRefs,
                processInfo: this._processInfo,
            });
            parentSpanId = rootSpanId;
        }
        // segment存起来
        this._segmentPool.set(segment.segmentId, segment);
        return this._startSpan({
            operationName: operationName,
            options: options,
            traceId: traceId,
            parentSpanId: parentSpanId,
            segment: segment,
            startTime: options === null || options === void 0 ? void 0 : options.startTime,
        });
    };
    // 用指定的context生成span, 通常用于生成父级span
    Tracer.prototype.startSpanWithContext = function (operationName, options) {
        var _a;
        var context = (_a = options === null || options === void 0 ? void 0 : options.context) !== null && _a !== void 0 ? _a : null;
        // 如果context不合法或者不采样
        if (!this._isContextValid(context) || !(context === null || context === void 0 ? void 0 : context.sampleDecision)) {
            return this._createNoopSpanWithContext(context);
        }
        var traceId = context.traceId;
        // 用context生成当前span是不知道父级的, 所以parentSpanId为rootSpanId, segmentRefs为[]
        var parentSpanId = rootSpanId;
        var segmentRefs = [];
        var segment = new Segment({
            tracer: this,
            traceId: traceId,
            segmentId: context.segmentId,
            segmentRefs: segmentRefs,
            processInfo: this._processInfo,
        });
        // segment存起来
        this._segmentPool.set(segment.segmentId, segment);
        return this._startSpan({
            operationName: operationName,
            options: options,
            traceId: traceId,
            parentSpanId: parentSpanId,
            segment: segment,
            startTime: options === null || options === void 0 ? void 0 : options.startTime,
        });
    };
    // 这名字有点怪, 换成startContext？
    Tracer.prototype.createContext = function (options) {
        var _a, _b, _c, _d;
        var traceId = (_a = options === null || options === void 0 ? void 0 : options.traceId) !== null && _a !== void 0 ? _a : createDistributeId(this._serviceName);
        var segmentId = (_b = options === null || options === void 0 ? void 0 : options.segmentId) !== null && _b !== void 0 ? _b : createDistributeId(this._serviceName);
        // 生成新的context spanId不能为-1, 需要从0开始, 因为后面的span要已这个context作为父级
        // 如果为-1, 计算出来的parentSpanId会是这种CAEQkMqxKBjc8scKILeIxKSuLijpBw==____-1, 会找不到
        var spanId = (_c = options === null || options === void 0 ? void 0 : options.spanId) !== null && _c !== void 0 ? _c : 0;
        var sampleDecision = (_d = options === null || options === void 0 ? void 0 : options.sampleDecision) !== null && _d !== void 0 ? _d : this._getSampleDecision();
        return new Context({
            traceId: traceId,
            segmentId: segmentId,
            spanId: spanId,
            serviceName: this._serviceName,
            bizName: this._bizName,
            sampleDecision: sampleDecision,
        });
    };
    Tracer.prototype._startSpan = function (_a) {
        var _b, _c, _d;
        var operationName = _a.operationName, options = _a.options, traceId = _a.traceId, segment = _a.segment, parentSpanId = _a.parentSpanId, startTime = _a.startTime;
        if (!operationName) {
            log$4('startSpan: operationName is needed');
            return new NoopSpan();
        }
        if (this._checkIsTraceIdOverdue(traceId)) {
            log$4('startSpan: traceId is overdue');
            return new NoopSpan();
        }
        var componentType = (_b = options === null || options === void 0 ? void 0 : options.componentType) !== null && _b !== void 0 ? _b : "LOCAL" /* LOCAL */;
        var componentName = (_c = options === null || options === void 0 ? void 0 : options.componentName) !== null && _c !== void 0 ? _c : operationName;
        var peerInfo = (_d = options === null || options === void 0 ? void 0 : options.peerInfo) !== null && _d !== void 0 ? _d : {};
        // 生成新的Context, 作为span的Context
        var newContext = this.createContext({
            traceId: traceId,
            segmentId: segment.segmentId,
            spanId: segment.spanLength,
            sampleDecision: true,
        });
        var span = new Span({
            tracer: this,
            segment: segment,
            operationName: operationName,
            context: newContext,
            spanId: newContext.spanId,
            parentSpanId: parentSpanId,
            componentType: componentType,
            componentName: componentName,
            peerInfo: peerInfo,
            startTime: startTime,
        });
        // 加一个统一的语言标识
        span.setTag('ktrace_sdk_lang', 'js');
        // 加上serviceName
        // span.setTag('serviceName', this.serviceName);
        // 加上用户userId, userId可能为0
        if (this.userId !== '') {
            span.setTag('userId', this.userId);
        }
        return span;
    };
    // 导出数据
    Tracer.prototype.export = function (segment) {
        var _this = this;
        this._exporter
            .export(segment)
            .then(function (data) {
            _this._transport.send(data);
            _this._contextManager.clear();
            _this._segmentPool.delete(segment.segmentId);
        })
            .catch(function (err) {
            log$4('export error:', err);
        });
    };
    // 可以从外部设置port
    Tracer.prototype.setPort = function (port) {
        this._processInfo.port = port;
    };
    // 设置自定义采样函数
    Tracer.prototype.setCustomSampleFn = function (fn) {
        this._customSampleFn = fn;
    };
    // 注入context
    Tracer.prototype.inject = function (propagator, ctx, carrier) {
        return propagator.inject(ctx, carrier);
    };
    // 提取context
    Tracer.prototype.extract = function (propagator, carrier) {
        var str = propagator.extract(carrier);
        if (!str) {
            return null;
        }
        var context = Context.fromString(str);
        return context;
    };
    // traceId中的时间, 如果离当前时间超过一小时, 则判定为逾期
    Tracer.prototype._checkIsTraceIdOverdue = function (traceId) {
        var distributeId = parseDistributeId(traceId);
        if (!isPlainObject(distributeId)) {
            return true;
        }
        if (typeof distributeId.timestamp !== 'number') {
            return true;
        }
        return Date.now() - distributeId.timestamp > 60 * 60 * 1000;
    };
    Tracer.prototype.dispose = function () {
        if (this._transport.dispose) {
            this._transport.dispose();
        }
    };
    Tracer.prototype._createNoopSpanWithContext = function (context) {
        var _a;
        if (this.alwaysCreateTraceId) {
            // 新建一个context, 有真实的traceId, 其他都是mock的
            var newContext = this.createContext({
                traceId: (_a = context === null || context === void 0 ? void 0 : context.traceId) !== null && _a !== void 0 ? _a : createDistributeId(this.serviceName),
                segmentId: noopSpanSegmentId,
                spanId: rootSpanId,
                sampleDecision: false,
            });
            return new NoopSpan({
                context: newContext,
            });
        }
        return new NoopSpan();
    };
    return Tracer;
}());

var NoopTracer = /** @class */ (function () {
    function NoopTracer() {
    }
    NoopTracer.prototype.startSpan = function () {
        return new NoopSpan();
    };
    NoopTracer.prototype.startSpanWithContext = function () {
        return new NoopSpan();
    };
    NoopTracer.prototype.createContext = function () {
        return null;
    };
    NoopTracer.prototype.export = function () { };
    NoopTracer.prototype.setPort = function (port) { };
    NoopTracer.prototype.setCustomSampleFn = function (fn) { };
    NoopTracer.prototype.inject = function (propagator, ctx, carrier) {
        return carrier;
    };
    NoopTracer.prototype.extract = function (propagator, carrier) {
        return null;
    };
    // webTracer的方法
    NoopTracer.prototype.stopFmp = function () { };
    NoopTracer.prototype.setGlobalData = function (_a) {
        var userId = _a.userId;
    };
    return NoopTracer;
}());

var HttpTextPropagator = /** @class */ (function () {
    function HttpTextPropagator() {
    }
    HttpTextPropagator.prototype.inject = function (ctx, carrier) {
        var _a;
        if (!ctx) {
            return carrier;
        }
        // fetch中的header类型是[object Headers]
        if (!isPlainObject(carrier) && !isHeader(carrier)) {
            return carrier;
        }
        try {
            return Object.assign({}, carrier, (_a = {},
                _a[KTRACE_STR_HEADER_KEY] = ctx.toString(),
                _a));
        }
        catch (_b) {
            return carrier;
        }
    };
    HttpTextPropagator.prototype.extract = function (carrier) {
        if (carrier === void 0) { carrier = {}; }
        return carrier[KTRACE_STR_HEADER_KEY] || null;
    };
    return HttpTextPropagator;
}());

/**
 * run in Browser
 */
var log$5 = browser('ktrace:web:propagator:cookie');
var CookiePropagator = /** @class */ (function () {
    function CookiePropagator() {
    }
    CookiePropagator.prototype.inject = function (ctx, carrier) {
        document.cookie = KTRACE_CONTEXT + "=" + encodeURIComponent(ctx.toString());
        return carrier;
    };
    CookiePropagator.prototype.extract = function () {
        var cookieTraceIdRegx = new RegExp(KTRACE_CONTEXT + '=([^;]+)');
        var match = document.cookie.match(cookieTraceIdRegx);
        if (match) {
            log$5('extract context', match[1]);
        }
        log$5('remove cookie');
        var date = new Date(Date.now() - 3600 * 24 * 1000);
        document.cookie = KTRACE_CONTEXT + "=; expires=" + date.toUTCString() + "; path=/";
        log$5('after remove', document.cookie);
        return match
            ? decodeURIComponent(match[1])
            : null;
    };
    return CookiePropagator;
}());
var cookiePropagator = new CookiePropagator();

var log$6 = browser('ktrace:core:BasePlugin');
var BasePlugin = /** @class */ (function () {
    function BasePlugin() {
        this._enable = false;
    }
    BasePlugin.prototype.enable = function (_a) {
        var exports = _a.exports, tracer = _a.tracer, name = _a.name, baseDir = _a.baseDir;
        this._exports = exports;
        this._tracer = tracer;
        this._enable = true;
        this._name = name !== null && name !== void 0 ? name : '';
        this._baseDir = baseDir !== null && baseDir !== void 0 ? baseDir : '';
        try {
            this.start();
        }
        catch (e) {
            log$6("plugin " + name + " start error: " + e);
            console.log("plugin " + name + " start error: " + e);
        }
    };
    // 默认启动, 这里提供一个禁用方法
    BasePlugin.prototype.disable = function () {
        this._enable = false;
        try {
            this.stop();
        }
        catch (e) {
            log$6("plugin " + name + " stop error: " + e);
            console.log("plugin " + name + " stop error: " + e);
        }
    };
    Object.defineProperty(BasePlugin.prototype, "exports", {
        get: function () {
            return this._exports;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlugin.prototype, "tracer", {
        get: function () {
            return this._tracer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlugin.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlugin.prototype, "baseDir", {
        get: function () {
            return this._baseDir;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BasePlugin.prototype, "isEnabled", {
        get: function () {
            return this._enable;
        },
        enumerable: false,
        configurable: true
    });
    return BasePlugin;
}());

function xhrAgent(options) {
    return new Promise(function (resolve, reject) {
        var _a, _b;
        try {
            var xhr_1 = new XMLHttpRequest();
            var method = (_a = options.method) !== null && _a !== void 0 ? _a : 'POST';
            var timeout = (_b = options.timeout) !== null && _b !== void 0 ? _b : 30000;
            xhr_1.open(method.toUpperCase(), options.url, true);
            xhr_1.setRequestHeader('Content-Type', 'application/json');
            xhr_1.timeout = timeout;
            xhr_1.onload = function () {
                resolve(JSON.parse(xhr_1.response));
            };
            xhr_1.ontimeout = xhr_1.onerror = function () {
                reject();
                xhr_1 = null;
            };
            // console.log('xhrAgent:', options.data);
            xhr_1.send(JSON.stringify(options.data));
        }
        catch (e) {
            // console.log(e);
            reject(e);
        }
    });
}

/*!
 * weakmap-polyfill v2.0.2 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2020 Polygon Planet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */

(function(self) {

  if (self.WeakMap) {
    return;
  }

  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var defineProperty = function(object, name, value) {
    if (Object.defineProperty) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };

  self.WeakMap = (function() {

    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }

      defineProperty(this, '_id', genId('_WeakMap'));

      // ECMA-262 23.3.1.1 WeakMap([iterable])
      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    }

    // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
    defineProperty(WeakMap.prototype, 'delete', function(key) {
      checkInstance(this, 'delete');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];
      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }

      return false;
    });

    // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
    defineProperty(WeakMap.prototype, 'get', function(key) {
      checkInstance(this, 'get');

      if (!isObject(key)) {
        return void 0;
      }

      var entry = key[this._id];
      if (entry && entry[0] === key) {
        return entry[1];
      }

      return void 0;
    });

    // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
    defineProperty(WeakMap.prototype, 'has', function(key) {
      checkInstance(this, 'has');

      if (!isObject(key)) {
        return false;
      }

      var entry = key[this._id];
      if (entry && entry[0] === key) {
        return true;
      }

      return false;
    });

    // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
    defineProperty(WeakMap.prototype, 'set', function(key, value) {
      checkInstance(this, 'set');

      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }

      var entry = key[this._id];
      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }

      defineProperty(key, this._id, [key, value]);
      return this;
    });


    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(
          methodName + ' method called on incompatible receiver ' +
          typeof x
        );
      }
    }

    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }

    function rand() {
      return Math.random().toString().substring(2);
    }


    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  })();


  function isObject(x) {
    return Object(x) === x;
  }

})(
  typeof self !== 'undefined' ? self :
  typeof window !== 'undefined' ? window :
  typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal
);

var log$7 = browser('ktrace:web:plugin:xhr');
var XhrPlugin = /** @class */ (function (_super) {
    __extends(XhrPlugin, _super);
    function XhrPlugin() {
        var _this = _super.call(this) || this;
        _this._xhrMap = new WeakMap();
        _this._propatator = new HttpTextPropagator();
        return _this;
    }
    XhrPlugin.prototype.start = function () {
        patch(XMLHttpRequest.prototype, 'open', this._patchOpen.bind(this));
        patch(XMLHttpRequest.prototype, 'send', this._patchSend.bind(this));
    };
    XhrPlugin.prototype.stop = function () {
        unpatch(XMLHttpRequest.prototype, 'open');
        unpatch(XMLHttpRequest.prototype, 'send');
    };
    XhrPlugin.prototype._patchOpen = function (original) {
        var plugin = this;
        var tracer = plugin.tracer;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var method = args[0];
            var url = args[1];
            var async = !!args[2];
            var pathname = getPathnameFromUrl(url);
            if (plugin._shouldIgnore(url) || plugin._shouldIgnore(pathname)) {
                log$7('xhr ignoreUrl:', pathname);
                return original.apply(this, args);
            }
            // 只处理异步的request
            if (async) {
                var span = tracer.startSpan(pathname, {
                    componentType: "WEB_SERVICE_HTTP" /* WEB_SERVICE_HTTP */,
                    componentName: 'web_xhr_client',
                    // fmpSpan的hack逻辑
                    // @ts-ignore
                    parent: tracer.hasFmpSpan ? tracer.fmpSpan : null,
                });
                span.setTag("http.method" /* HTTP_METHOD */, method);
                plugin._xhrMap.set(this, {
                    span: span,
                    url: url,
                });
            }
            return original.apply(this, args);
        };
    };
    XhrPlugin.prototype._patchSend = function (original) {
        var plugin = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var xhr = this;
            if (!plugin._xhrMap.has(xhr)) {
                return original.apply(this, args);
            }
            var span = plugin._xhrMap.get(xhr).span;
            function handleEvent(e) {
                var _a;
                if (e.type === 'error' || e.type === 'timeout') {
                    span.setError(e);
                }
                if (e.type === 'load') {
                    span.setTags((_a = {},
                        _a["http.status_code" /* STATUS_CODE */] = this.status,
                        _a));
                }
                span.end();
                // eslint-disable-next-line
                remove();
            }
            function remove() {
                xhr.removeEventListener('abort', handleEvent);
                xhr.removeEventListener('load', handleEvent);
                xhr.removeEventListener('error', handleEvent);
                xhr.removeEventListener('timeout', handleEvent);
            }
            function addListerner() {
                xhr.addEventListener('abort', handleEvent);
                xhr.addEventListener('load', handleEvent);
                xhr.addEventListener('error', handleEvent);
                xhr.addEventListener('timeout', handleEvent);
            }
            addListerner();
            // 设置header
            if (span.context) {
                this.setRequestHeader(KTRACE_STR_HEADER_KEY, span.context.toString());
            }
            return original.apply(this, args);
        };
    };
    // ignoreUrl过滤, 浏览器端取不到header, 就用url来判断
    XhrPlugin.prototype._shouldIgnore = function (url) {
        return isShouldIgnore(this.tracer.ignoreUrlList, url) || isKtraceInternalUrl(url);
    };
    return XhrPlugin;
}(BasePlugin));

var log$8 = browser('ktrace:web:plugin:fetch');
var FetchPlugin = /** @class */ (function (_super) {
    __extends(FetchPlugin, _super);
    function FetchPlugin() {
        var _this = _super.call(this) || this;
        _this._propatator = new HttpTextPropagator();
        return _this;
    }
    FetchPlugin.prototype.start = function () {
        if (isBrowser() && window.fetch) {
            patch(window, 'fetch', this._patchFetch.bind(this));
        }
    };
    FetchPlugin.prototype.stop = function () {
        if (isBrowser() && window.fetch) {
            unpatch(window, 'fetch');
        }
    };
    FetchPlugin.prototype._patchFetch = function (original) {
        var plugin = this;
        var tracer = this.tracer;
        return function (input, init) {
            var _this = this;
            var _a = plugin._getRequestInfo(input, init), url = _a.url, method = _a.method;
            var pathname = getPathnameFromUrl(url);
            if (plugin._shouldIgnore(url) || plugin._shouldIgnore(pathname)) {
                log$8('fetch ignoreUrl:', pathname);
                return original.apply(this, [input, init]);
            }
            // 先简单点适配下pc直播, 后续根据需求, 是否用户自定义
            var isGraphql = ['/graphql', '/m_graphql'].indexOf(pathname) > -1;
            if (isGraphql) {
                try {
                    var body = void 0;
                    if (input instanceof Request) {
                        body = JSON.parse(input.body);
                    }
                    else if (typeof init !== 'undefined') {
                        body = JSON.parse(init.body);
                    }
                    if (body && body.operationName) {
                        pathname = pathname + "_" + body.operationName;
                    }
                }
                catch (e) {
                    //
                }
            }
            var span = tracer.startSpan(pathname, {
                componentType: "WEB_SERVICE_HTTP" /* WEB_SERVICE_HTTP */,
                componentName: 'web_fetch_client',
                // fmpSpan的hack逻辑
                // @ts-ignore TODO: 这里如何引用webTracer
                parent: tracer.hasFmpSpan ? tracer.fmpSpan : null,
            });
            span.setTag("http.method" /* HTTP_METHOD */, method);
            var headers = {};
            // context注入下游
            if (span.context) {
                headers[KTRACE_STR_HEADER_KEY] = span.context.toString();
            }
            if (typeof init === 'undefined') {
                init = {};
            }
            init.headers = Object.assign({}, headers, init.headers || {});
            return new Promise(function (resolve, reject) {
                original.apply(_this, [input, init])
                    .then(function (res) {
                    resolve(res);
                    span.end();
                })
                    // fetch很难报错, 所以这个catch可能没什么用
                    .catch(function (err) {
                    reject(err);
                    span.setError(err);
                    span.end();
                });
            });
        };
    };
    FetchPlugin.prototype._getRequestInfo = function (input, init) {
        var defaultObj = {
            url: '/',
            method: 'GET',
        };
        // 只有一个参数
        if (typeof init === 'undefined') {
            if (typeof input === 'string') {
                return {
                    url: input,
                    method: 'GET',
                };
            }
            if (input instanceof Request) {
                return {
                    url: input.url,
                    method: (input.method || 'GET').toUpperCase(),
                };
            }
            return defaultObj;
        }
        if (typeof input === 'string') {
            return {
                url: input,
                method: (init.method || 'GET').toUpperCase(),
            };
        }
        if (input instanceof Request) {
            // 同时有input和init, init优先, 参考了node fetch实现
            return {
                url: input.url || '/',
                method: (init.method || input.method || 'GET').toUpperCase(),
            };
        }
        return defaultObj;
    };
    // ignoreUrl过滤, 浏览器端取不到header, 就用url来判断
    FetchPlugin.prototype._shouldIgnore = function (url) {
        return isShouldIgnore(this.tracer.ignoreUrlList, url) || isKtraceInternalUrl(url);
    };
    return FetchPlugin;
}(BasePlugin));

var perfMap = [
    {
        name: 'dns',
        start: 'domainLookupStart',
        end: 'domainLookupEnd',
    },
    {
        name: 'tcp',
        start: 'connectStart',
        end: 'connectEnd',
    },
    {
        name: 'request',
        start: 'requestStart',
        end: 'responseStart',
    },
    {
        name: 'response',
        start: 'responseStart',
        end: 'responseEnd',
    },
    // domLoading时间, 从加载结束到可交互
    {
        name: 'domLoading',
        start: 'responseEnd',
        end: 'domInteractive',
    },
    {
        name: 'unloadEvent',
        start: 'unloadEventStart',
        end: 'unloadEventEnd',
    },
    // dom可交互时间, 从可交互到ContentLoaded, 不知道这样算有没有问题
    {
        name: 'domInteractive',
        start: 'domInteractive',
        end: 'domContentLoadedEventStart',
    },
    {
        name: 'domContentLoadedEvent',
        start: 'domContentLoadedEventStart',
        end: 'domContentLoadedEventEnd',
    },
    {
        name: 'domComplete',
        start: 'domContentLoadedEventEnd',
        end: 'domComplete',
    },
    {
        name: 'loadEvent',
        start: 'loadEventStart',
        end: 'loadEventEnd',
    },
];
function collectPerformanceTiming(tracer) {
    if (!isBrowser()) {
        return;
    }
    var timing;
    var isHighResTime = false;
    if (performance.getEntriesByType) {
        // @ts-ignore
        timing = performance.getEntriesByType('navigation')[0];
        isHighResTime = true;
    }
    else {
        timing = performance.timing;
    }
    var url = window.location.href;
    perfMap.forEach(function (item) {
        var start = timing[item.start];
        var end = timing[item.end];
        // 对耗时为0的先不展示
        if (end <= start) {
            return;
        }
        var span = tracer.startSpan(url, {
            // @ts-ignore
            parent: tracer.fmpSpan,
            componentType: "LOCAL" /* LOCAL */,
            componentName: item.name,
            // 这里的小数相加可能有精度问题
            startTime: isHighResTime ? start + getTimeOrigin() : start,
        });
        // 对高精度毫秒时间, 转成nanos再计算
        if (isHighResTime) {
            var nanos = Math.trunc(end * MILLI_TO_NANO) - Math.trunc(start * MILLI_TO_NANO);
            span.setDuration(nanos / MILLI_TO_NANO);
        }
        else {
            span.setDuration(end - start);
        }
        span.end();
    });
}

var resourcePerfMap = [
    {
        name: 'dns',
        start: 'domainLookupStart',
        end: 'domainLookupEnd',
    },
    {
        name: 'tcp',
        start: 'connectStart',
        end: 'connectEnd',
    },
    {
        name: 'request',
        start: 'requestStart',
        end: 'responseStart',
    },
    {
        name: 'response',
        start: 'responseStart',
        end: 'responseEnd',
    },
];
var resourceIgnoreList = ['xmlhttprequest', 'fetch'];
// resourceTiming先处理css和js和img, xhr/fetch放plugin里处理
function collectPerformanceResourceTiming(tracer) {
    if (!isBrowser()) {
        return;
    }
    if (!performance.getEntriesByType) {
        return;
    }
    performance.getEntriesByType('resource')
        .filter(function (item) {
        return resourceIgnoreList.indexOf(item.initiatorType) === -1;
    })
        .forEach(function (item) {
        var name = item.name, initiatorType = item.initiatorType, decodedBodySize = item.decodedBodySize, encodedBodySize = item.encodedBodySize, transferSize = item.transferSize, duration = item.duration, nextHopProtocol = item.nextHopProtocol, fetchStart = item.fetchStart;
        var span = tracer.startSpan(name, {
            // @ts-ignore
            parent: tracer.fmpSpan,
            componentType: "LOCAL" /* LOCAL */,
            componentName: initiatorType,
            startTime: fetchStart + getTimeOrigin(),
        });
        span.setDuration(duration);
        span.setTags({
            url: name,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            transferSize: transferSize,
            nextHopProtocol: nextHopProtocol,
        });
        resourcePerfMap.forEach(function (perfMap) {
            var start = item[perfMap.start];
            var end = item[perfMap.end];
            // 对耗时为0的先不展示
            if (end <= start) {
                return;
            }
            var resourcePerfSpan = tracer.startSpan(name, {
                // @ts-ignore
                parent: span,
                componentType: "LOCAL" /* LOCAL */,
                componentName: perfMap.name,
                // 这里的小数相加可能有精度问题
                startTime: start + getTimeOrigin(),
            });
            // 对高精度毫秒时间, 转成nanos再计算
            var durationNanos = Math.trunc(end * MILLI_TO_NANO) - Math.trunc(start * MILLI_TO_NANO);
            resourcePerfSpan
                .setDuration(durationNanos / MILLI_TO_NANO)
                .end();
        });
        span.end();
    });
}

// 这两个时间不适合放在trace里作为span, 放tag里更合适
function collectPerformancePaintTiming() {
    if (!isBrowser()) {
        return [];
    }
    if (!performance.getEntriesByType) {
        return [];
    }
    try {
        return performance.getEntriesByType('paint')
            .map(function (item) {
            var _a;
            return _a = {},
                _a[item.name] = item.startTime,
                _a;
        });
    }
    catch (e) {
        return [];
    }
}

var store2 = createCommonjsModule(function (module) {
(function(window, define) {
    var _ = {
        version: "2.11.2",
        areas: {},
        apis: {},

        // utilities
        inherit: function(api, o) {
            for (var p in api) {
                if (!o.hasOwnProperty(p)) {
                    Object.defineProperty(o, p, Object.getOwnPropertyDescriptor(api, p));
                }
            }
            return o;
        },
        stringify: function(d) {
            return d === undefined || typeof d === "function" ? d+'' : JSON.stringify(d);
        },
        parse: function(s, fn) {
            // if it doesn't parse, return as is
            try{ return JSON.parse(s,fn||_.revive); }catch(e){ return s; }
        },

        // extension hooks
        fn: function(name, fn) {
            _.storeAPI[name] = fn;
            for (var api in _.apis) {
                _.apis[api][name] = fn;
            }
        },
        get: function(area, key){ return area.getItem(key); },
        set: function(area, key, string){ area.setItem(key, string); },
        remove: function(area, key){ area.removeItem(key); },
        key: function(area, i){ return area.key(i); },
        length: function(area){ return area.length; },
        clear: function(area){ area.clear(); },

        // core functions
        Store: function(id, area, namespace) {
            var store = _.inherit(_.storeAPI, function(key, data, overwrite) {
                if (arguments.length === 0){ return store.getAll(); }
                if (typeof data === "function"){ return store.transact(key, data, overwrite); }// fn=data, alt=overwrite
                if (data !== undefined){ return store.set(key, data, overwrite); }
                if (typeof key === "string" || typeof key === "number"){ return store.get(key); }
                if (typeof key === "function"){ return store.each(key); }
                if (!key){ return store.clear(); }
                return store.setAll(key, data);// overwrite=data, data=key
            });
            store._id = id;
            try {
                var testKey = '_-bad-_';
                area.setItem(testKey, 'wolf');
                store._area = area;
                area.removeItem(testKey);
            } catch (e) {}
            if (!store._area) {
                store._area = _.storage('fake');
            }
            store._ns = namespace || '';
            if (!_.areas[id]) {
                _.areas[id] = store._area;
            }
            if (!_.apis[store._ns+store._id]) {
                _.apis[store._ns+store._id] = store;
            }
            return store;
        },
        storeAPI: {
            // admin functions
            area: function(id, area) {
                var store = this[id];
                if (!store || !store.area) {
                    store = _.Store(id, area, this._ns);//new area-specific api in this namespace
                    if (!this[id]){ this[id] = store; }
                }
                return store;
            },
            namespace: function(namespace, singleArea) {
                if (!namespace){
                    return this._ns ? this._ns.substring(0,this._ns.length-1) : '';
                }
                var ns = namespace, store = this[ns];
                if (!store || !store.namespace) {
                    store = _.Store(this._id, this._area, this._ns+ns+'.');//new namespaced api
                    if (!this[ns]){ this[ns] = store; }
                    if (!singleArea) {
                        for (var name in _.areas) {
                            store.area(name, _.areas[name]);
                        }
                    }
                }
                return store;
            },
            isFake: function(){ return this._area.name === 'fake'; },
            toString: function() {
                return 'store'+(this._ns?'.'+this.namespace():'')+'['+this._id+']';
            },

            // storage functions
            has: function(key) {
                if (this._area.has) {
                    return this._area.has(this._in(key));//extension hook
                }
                return !!(this._in(key) in this._area);
            },
            size: function(){ return this.keys().length; },
            each: function(fn, fill) {// fill is used by keys(fillList) and getAll(fillList))
                for (var i=0, m=_.length(this._area); i<m; i++) {
                    var key = this._out(_.key(this._area, i));
                    if (key !== undefined) {
                        if (fn.call(this, key, this.get(key), fill) === false) {
                            break;
                        }
                    }
                    if (m > _.length(this._area)) { m--; i--; }// in case of removeItem
                }
                return fill || this;
            },
            keys: function(fillList) {
                return this.each(function(k, v, list){ list.push(k); }, fillList || []);
            },
            get: function(key, alt) {
                var s = _.get(this._area, this._in(key)),
                    fn;
                if (typeof alt === "function") {
                    fn = alt;
                    alt = null;
                }
                return s !== null ? _.parse(s, fn) :
                    alt != null ? alt : s;
            },
            getAll: function(fillObj) {
                return this.each(function(k, v, all){ all[k] = v; }, fillObj || {});
            },
            transact: function(key, fn, alt) {
                var val = this.get(key, alt),
                    ret = fn(val);
                this.set(key, ret === undefined ? val : ret);
                return this;
            },
            set: function(key, data, overwrite) {
                var d = this.get(key);
                if (d != null && overwrite === false) {
                    return data;
                }
                return _.set(this._area, this._in(key), _.stringify(data), overwrite) || d;
            },
            setAll: function(data, overwrite) {
                var changed, val;
                for (var key in data) {
                    val = data[key];
                    if (this.set(key, val, overwrite) !== val) {
                        changed = true;
                    }
                }
                return changed;
            },
            add: function(key, data) {
                var d = this.get(key);
                if (d instanceof Array) {
                    data = d.concat(data);
                } else if (d !== null) {
                    var type = typeof d;
                    if (type === typeof data && type === 'object') {
                        for (var k in data) {
                            d[k] = data[k];
                        }
                        data = d;
                    } else {
                        data = d + data;
                    }
                }
                _.set(this._area, this._in(key), _.stringify(data));
                return data;
            },
            remove: function(key, alt) {
                var d = this.get(key, alt);
                _.remove(this._area, this._in(key));
                return d;
            },
            clear: function() {
                if (!this._ns) {
                    _.clear(this._area);
                } else {
                    this.each(function(k){ _.remove(this._area, this._in(k)); }, 1);
                }
                return this;
            },
            clearAll: function() {
                var area = this._area;
                for (var id in _.areas) {
                    if (_.areas.hasOwnProperty(id)) {
                        this._area = _.areas[id];
                        this.clear();
                    }
                }
                this._area = area;
                return this;
            },

            // internal use functions
            _in: function(k) {
                if (typeof k !== "string"){ k = _.stringify(k); }
                return this._ns ? this._ns + k : k;
            },
            _out: function(k) {
                return this._ns ?
                    k && k.indexOf(this._ns) === 0 ?
                        k.substring(this._ns.length) :
                        undefined : // so each() knows to skip it
                    k;
            }
        },// end _.storeAPI
        storage: function(name) {
            return _.inherit(_.storageAPI, { items: {}, name: name });
        },
        storageAPI: {
            length: 0,
            has: function(k){ return this.items.hasOwnProperty(k); },
            key: function(i) {
                var c = 0;
                for (var k in this.items){
                    if (this.has(k) && i === c++) {
                        return k;
                    }
                }
            },
            setItem: function(k, v) {
                if (!this.has(k)) {
                    this.length++;
                }
                this.items[k] = v;
            },
            removeItem: function(k) {
                if (this.has(k)) {
                    delete this.items[k];
                    this.length--;
                }
            },
            getItem: function(k){ return this.has(k) ? this.items[k] : null; },
            clear: function(){ for (var k in this.items){ this.removeItem(k); } }
        }// end _.storageAPI
    };

    var store =
        // safely set this up (throws error in IE10/32bit mode for local files)
        _.Store("local", (function(){try{ return localStorage; }catch(e){}})());
    store.local = store;// for completeness
    store._ = _;// for extenders and debuggers...
    // safely setup store.session (throws exception in FF for file:/// urls)
    store.area("session", (function(){try{ return sessionStorage; }catch(e){}})());
    store.area("page", _.storage("page"));

    if (typeof define === 'function' && define.amd !== undefined) {
        define('store2', [], function () {
            return store;
        });
    } else if ( module.exports) {
        module.exports = store;
    } else {
        // expose the primary store fn to the global object and save conflicts
        if (window.store){ _.conflict = window.store; }
        window.store = store;
    }

})(commonjsGlobal, commonjsGlobal && commonjsGlobal.define);
});

var webPluginMap = {
    xhr: new XhrPlugin(),
    fetch: new FetchPlugin(),
};
var log$9 = browser('ktrace:web:tracer');
var WebTracer = /** @class */ (function (_super) {
    __extends(WebTracer, _super);
    function WebTracer(options) {
        var _a;
        var _this = _super.call(this, options) || this;
        _this._fmpSpan = null;
        // 临时性的过渡方案
        _this._resourceTiming = false;
        // 保留最近的一次trace信息, 这样下次进来就可以复用
        // 异步登录且多账号的情况会保存最近一个账号登录的信息
        _this._ktraceKey = '__KTRACE_INFO__';
        _this._setHttpAgent(xhrAgent);
        // 传给父类, 在startSpan的时候设置tag, 需要在getTraceInfo的前面
        if (typeof options.userId !== 'undefined') {
            _this._setUserId(options.userId);
        }
        _this._getTraceInfoFromLocal();
        _this._setProcessInfo();
        _this._resourceTiming = (_a = options === null || options === void 0 ? void 0 : options.resourceTiming) !== null && _a !== void 0 ? _a : false;
        // 当本地有TraceInfo, 并且用户设置了延迟设置userId, 则初始化时不再请求traceInfo, 而直接使用本地数据
        // 当用户setGlobalData时，再请求traceInfo并更新用户信息
        // 这是为了解决在一些异步获取userId的场景下, 第一次无userId的请求会覆盖本地存储
        if (!(_this._checkTraceInfoInLocal() && options.setUserIdAsync)) {
            _this._getTraceInfo();
        }
        // loadPlugin需要放在startFmpSpan之后
        if (options.fmp) {
            _this._startFmpSpan();
        }
        _this._loadPlugin(options.disablePluginList);
        _this._onLoad();
        return _this;
    }
    WebTracer.prototype._getTraceInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, res, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "" + HOST_ONLINE + INFO_PATH;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.httpAgent({
                                url: url,
                                method: 'post',
                                data: {
                                    serviceName: this.serviceName,
                                    userId: this.userId,
                                },
                            })];
                    case 2:
                        res = _a.sent();
                        if (res.result === 1) {
                            this._setTraceInfo(res.data);
                            store2.set(this._ktraceKey, res.data);
                        }
                        else {
                            console.log('oops! get ktrace info error:', res);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log('oops! get ktrace info error:', err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    WebTracer.prototype._checkTraceInfoInLocal = function () {
        return store2.has(this._ktraceKey);
    };
    // web会先去本地读取一次, 等远程数据回来之后再更新
    WebTracer.prototype._getTraceInfoFromLocal = function () {
        if (this._checkTraceInfoInLocal()) {
            this._setTraceInfo(store2(this._ktraceKey));
        }
    };
    WebTracer.prototype._loadPlugin = function (disablePluginList) {
        var _this = this;
        if (disablePluginList === void 0) { disablePluginList = []; }
        Object.keys(webPluginMap).forEach(function (name) {
            if (disablePluginList.indexOf(name) === -1) {
                var plugin = webPluginMap[name];
                plugin.enable({
                    // web中这个exports并没什么用, 这里随便传一个
                    exports: name,
                    tracer: _this,
                });
            }
        });
    };
    WebTracer.prototype._startFmpSpan = function () {
        var url = window.location.href;
        var htmlCookieContext = this._getHtmlCookieContext();
        // 如果有cookie, 并且cookie是采样的
        // 因为node端拿不到白名单, htmlCookieContext很多sampleDecision是false
        if (htmlCookieContext && htmlCookieContext.sampleDecision) {
            log$9('use htmlCookieContext', htmlCookieContext);
            this._fmpSpan = this.startSpanWithContext(url, {
                componentType: "LOCAL" /* LOCAL */,
                componentName: 'fmp',
                context: htmlCookieContext,
                startTime: getTimeOrigin(),
            });
        }
        else {
            this._fmpSpan = this.startSpan(url, {
                componentType: "LOCAL" /* LOCAL */,
                componentName: 'fmp',
                startTime: getTimeOrigin(),
            });
        }
    };
    WebTracer.prototype._onLoad = function () {
        var _this = this;
        if (isBrowser()) {
            window.addEventListener('load', function () {
                if (!_this._fmpSpan) {
                    log$9('window.onload ignore for no fmpSpan found');
                    return;
                }
                _this.stopFmp();
            });
        }
    };
    Object.defineProperty(WebTracer.prototype, "fmpSpan", {
        get: function () {
            return this._fmpSpan;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WebTracer.prototype, "hasFmpSpan", {
        get: function () {
            return !!this._fmpSpan && !this._fmpSpan.isEnd();
        },
        enumerable: false,
        configurable: true
    });
    WebTracer.prototype._getHtmlCookieContext = function () {
        var cookieContext = this.extract(cookiePropagator, '');
        log$9('cookie Context', cookieContext);
        if (cookieContext) {
            return cookieContext;
        }
        return null;
    };
    WebTracer.prototype._collectPerformance = function () {
        if (!this.hasFmpSpan) {
            log$9('fmpSpan is not found or has end');
            return;
        }
        collectPerformanceTiming(this);
        if (this._resourceTiming) {
            collectPerformanceResourceTiming(this);
        }
    };
    // 这两个方法可以提出去
    WebTracer.prototype.stopFmp = function () {
        var _this = this;
        if (!this._fmpSpan) {
            log$9('stopFmp ignore for no fmpSpan found');
            return;
        }
        // catch下可能收集失败的场景
        try {
            // fmpSpan结束之前收集performance
            this._collectPerformance();
            // 收集paintTiming
            var paintTiming = collectPerformancePaintTiming();
            if (paintTiming.length) {
                paintTiming.forEach(function (item) {
                    _this._fmpSpan.setTags(item);
                });
            }
        }
        catch (e) {
            //
        }
        this._fmpSpan.end();
        this._fmpSpan = null;
    };
    // 设置一些公用方法, 如果有设置userId, 会重新取一次traceInfo
    // 如果设置为空, 要不要把本地存储的清掉, 或者重新提供一个新的方法
    WebTracer.prototype.setGlobalData = function (_a) {
        var userId = _a.userId;
        if (typeof userId !== 'undefined') {
            this._setUserId(userId);
            this._getTraceInfo();
        }
    };
    return WebTracer;
}(Tracer));
var defaultWebIgnoreUrlList = [
    '/rest/wd/common/log/collect/misc2',
    '/rest/wd/common/log/collect/radar',
];
var tracer;
function init(options) {
    var _a;
    if (isBrowser()) {
        options.ignoreUrlList = __spread(((_a = options.ignoreUrlList) !== null && _a !== void 0 ? _a : []), defaultWebIgnoreUrlList);
        tracer = new WebTracer(Object.assign({}, {
            // 默认打开首屏采集
            fmp: true,
        }, options));
    }
    else {
        tracer = new NoopTracer();
    }
    return tracer;
}
function stopFmp() {
    return tracer.stopFmp();
}
function setGlobalData(_a) {
    var userId = _a.userId;
    return tracer.setGlobalData({ userId: userId });
}

export { WebTracer, init, setGlobalData, stopFmp };
